import Client from '@/app/repository/axios-client';

const resource = '/application/applications';

export default {
  getFinancialSupportDetails(applicationId) {
    return Client.get(`${resource}/${applicationId}/financial-support/details`);
  },
  changeFinancialSupportAmount(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/financial-support/change-amount`, payload);
  }
}
